import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=02cf9d2e&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=02cf9d2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cf9d2e",
  null
  
)

export default component.exports